import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyUiIconModule, SkyUiSpinnerModule } from '@skyeng/libs/shared/ui-kit';
import { MaRoundComponent } from './components/ma-round/ma-round.component';

@NgModule({
  declarations: [MaRoundComponent],
  exports: [MaRoundComponent],
  imports: [CommonModule, SkyUiSpinnerModule, SkyUiIconModule],
})
export class MaRoundButtonModule {}
